/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

let prods = window.product
console.log(prods,1111)

      function getCur(){
        let opt1 = $('#color .active').attr('data-val');
        let opt2 = $('#amount .active').attr('data-val');
        // let opt3 = $('#size .active').attr('data-val');
        let cur = prods.filter(item => item.option1 == opt1 && item.option2 == opt2)[0];
        let num = $('#calcNumber').val();
        return {
          cur,
          num
        }
      }

      function changePrice(){
        let { cur,num } = getCur();

        console.log(cur,num)
        
        let p = cur.price;
        let cp = cur.compare_at_price || (p * 2);
        let tp = parseFloat(p * num / 100).toFixed(2).replace('.', ',');
        let tcp = parseFloat(cp * num / 100).toFixed(2).replace('.', ',');
        
        $('#price1 span').text(tp);
        $('#price2').html(`R$${tcp}<img src="https://cdn.shopify.com/s/files/1/0769/2206/1013/files/arrow-d.png?v=1708916912" alt="" class="icon">`);
        
      }
      
          $('.img-wrap>img').hide()
          $('.img-wrap>img').eq(0).show()

        $(".option").click(function () {
          $(this).siblings().removeClass("active");
          $(this).addClass("active");
          // let img2 = $(".p-img2");
          const index1 = $("#color .active").index();
          const index2 = $("#amount .active").index();

          let optionIndex  = index1 + index2 * 3

          $('.img-wrap>img').hide()

          $('.img-wrap>img').eq(optionIndex).show()

          // img2[0].src = `https://cdn.shopify.com/s/files/1/0769/2206/1013/files/3da7e40f3a613ec95c97a3f1ced5b451.png?v=1770362309`;

          // switch(index){
          //   case 0:
          //     $(".img-wrap .box p").html("Bomba manual")
          //      $(".img-wrap .box").show()
          //     img2[0].src = `https://cdn.shopify.com/s/files/1/0769/2206/1013/files/3da7e40f3a613ec95c97a3f1ced5b451.png?v=1770362309`;
          //     break;
          //   case 1:
          //     $(".img-wrap .box p").html("Bomba Elétrica")
          //      $(".img-wrap .box").show()
          //     img2[0].src = `https://cdn.shopify.com/s/files/1/0769/2206/1013/files/p-img.png?v=1708916912`;
          //     break;
          //   default:
          //     $(".img-wrap .box").hide()
              
          // }
          changePrice();
        });

$('.sp-btn-style').click(function(){
  // let num = $(this).siblings('.addGroup').find('input').val()
  let { cur,num } = getCur();

          window.location.href = '/cart/' + cur.id + ':' + num;
  // window.location.href = '/cart/' + id + ':' + num
})
// $(".sp-reduce").click(function () {
//   let input = $(this).siblings("input")[0];
//   let num = Number(input.value) - 1;
//   if (num > 0) {
//     input.value = num;
//     changePrice()
//   }
// });
// $(".sp-add").click(function () {
//   let input = $(this).siblings("input")[0];
//   let num = Number(input.value) + 1;
//   input.value = num;
//   changePrice()
// });

      $(".reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
          input.value = num;
          changePrice();
        }
      });
      $(".add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice();
      });

let spImgList = [];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            273 * $("div#root").css("zoom") -
            78 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

jQuery(".sp-scroll").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 12,
  vis: 3,
  scroll: 2,
});
